enum Role {
  VOLUNTEER = "VOLUNTEER",
  COORDINATOR = "COORDINATOR",
  ADMINISTRATOR = "ADMINISTRATOR",
  GUEST = "GUEST"
}

export default Role;
